import type { IMetadataRepository } from '../repositories/IMetadataRepository.js';

interface Deps { metadataRepository: IMetadataRepository; }
export function createDeleteMetadataUseCase({ metadataRepository }: Deps) {
  return async function deleteMetadata(id: string): Promise<void> {
    return metadataRepository.delete(id);
  };
}
